<template>
  <div v-if="errors" class="validation-errors">
    <span v-if="title">{{ title }}</span>
    <ul>
      <li
        v-for="(error, index) of errors"
        :key="`validation-errors__validation-error-${index}`"
        class="validation-errors__validation-error"
      >
        {{ render(error.param, error.msg) }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["title", "errors"],
  methods: {
    render(param, message) {
      return `${message.text}`;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../assets/styles/variables";

.validation-errors {
  font-size: 0.85rem;

  &__validation-error {
    list-style-type: decimal;
    color: @kk-color-red;
  }
}
</style>
